module.exports = __webpack_public_path__ + "static/media/Bubbly_ios_5.5fc0bb36.jpg";